// src/MainContent.jsx
import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Table from "./Table";
import Enqiery from "./enquiry/Enqiery";
import Dasboard from "./dashboard/Dasboard";
import AddStudent from "./student/ApprovedForms";
import ViewStudent from "./student/ViewStudent";
import Bill from "./Bill/Bill";
import AddBill from "./Bill/AddBill";
import BillDetails from "./Bill/BillDetails";
import OverallPayment from "./Bill/OverallPayment";
import InvoiceView from "./Bill/InvoiceView";
import Accounting from "./Accounting/Accounting";
import AddExpansive from "./Accounting/AddExpansive";
import ViewExpansive from "./Accounting/ViewExpansive";
import Setting from "./settings/Setting";
import MiscBillList from "./Bill/MiscBillList"; // New import
import PredefinedMiscItems from "./settings/PredefinedMiscItems";
import CategoriesCrud from "./settings/CategoriesCrud"; // New import
import BranchesCrud from "./settings/BranchesCrud"; // New import
import UserRegistration from "./UserRegistration"; // New import

const MainContent = () => {
  const navigate = useNavigate();

  return (
    <div className="flex-1 p-6">
      <Routes>
        <Route path="dashboard" element={<Dasboard />} />
        <Route path="admission" element={<Table />} />
        <Route path="enquiry" element={<Enqiery />} />
        <Route path="/admin/manageBranches" element={<BranchesCrud/>} />

        <Route path="student" element={<AddStudent onSelect={(path) => navigate(path)} />} />
        <Route path="viewstudent" element={<ViewStudent />} />
        <Route path="generateBill" element={<Bill onSelect={(path) => navigate(path)} />} />
        <Route path="addBill" element={<AddBill onBack={() => navigate("/admin/generateBill")} />} />
        <Route path="viewBill/:formId/:id" element={<BillDetails onBack={() => navigate("/admin/generateBill")} />} />
        <Route path="overall" element={<OverallPayment onSelect={(path) => navigate(path)} />} />
        <Route path="invoice/:id" element={<InvoiceView onBack={() => navigate("/admin/overall")} />} />
        <Route path="expan/:id?" element={<AddExpansive onBack={() => navigate("/admin/accounting")} />} />
        <Route path="accounting" element={<Accounting />} />
        <Route path="ViewExpan/:id" element={<ViewExpansive />} />
        <Route path="settings" element={<Setting />} />
        <Route path="viewMiscBills" element={<MiscBillList />} />
        <Route path="predefinedMiscItems" element={<PredefinedMiscItems />} />
        <Route path="manageCategories" element={<CategoriesCrud />} />
        <Route path="manageBranches" element={<BranchesCrud />} />
        <Route path="registerUser" element={<UserRegistration />} />
        <Route path="/" element={<h2 className="text-3xl font-semibold">Welcome to our website</h2>} />
      </Routes>
    </div>
  );
};

export default MainContent;


// export default MainContent;
